/* eslint-disable */
import React from "react";
import { useTranslation } from "react-i18next";

export default function DetailsFacebookApi() {
  const { t } = useTranslation();

  return (
    <div className="min-h-[420px] h-fit dark:!bg-[#181919]" dir={t("services.direction")}>
      <section className="relative max-w-screen-xl mx-auto py-4 px-4 md:px-8">
        <div className="flex flex-col md:flex-row gap-6">
          {/* Left Section: Description and Features */}
          <div className="flex-1">
            <h3 className="text-2xl font-bold text-gray-800 dark:!text-gray-200 mb-4">
              {t("services.facebook_api_conversions_integration_title")}
              <span className="text-[#9e68ba] dark:!text-[#bc7ade]">
                {t("services.facebook_api_conversions_integration_highlight")}
              </span>
            </h3>
            <p className="text-gray-600 dark:!text-gray-300 mb-6 leading-relaxed">
              {t("services.facebook_api_conversions_description")}
            </p>
            <div className="bg-[#fcf6ff] dark:!bg-[#222222] p-4 rounded-lg border border-[#fbf4ff] dark:!border-[#3c3a3d] mb-4">
              <h4 className="font-medium text-[#9e68ba] dark:!text-[#bc7ade] mb-2">
                {t("services.key_features")}
              </h4>
              <ul className="space-y-2 text-gray-700 dark:!text-gray-300">
                {t("services.facebook_api_conversions_features", { returnObjects: true }).map(
                  (feature, index) => (
                    <li key={index} className="flex items-center">
                      <span className="w-2 h-2 bg-purple-500 rounded-full mr-2"></span>
                      {feature}
                    </li>
                  )
                )}
              </ul>
            </div>
            <a
              className="inline-flex items-center px-4 py-2 text-[#9e68ba] dark:!text-[#bc7ade] bg-[#fcf6ff] dark:!bg-[#3c3a3d] rounded-lg font-medium transition-colors hover:bg-[#faf1ff] hover:dark:!bg-[#4a2a5a]"
              href="https://www.youtube.com/embed/placeholder"
              target="_blank"
              rel="noopener noreferrer"
              aria-label={t("services.watch_integration_video")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 mr-2"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                <path
                  fillRule="evenodd"
                  d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                  clipRule="evenodd"
                />
              </svg>
              {t("services.watch_integration_video")}
            </a>
          </div>

          {/* Right Section: YouTube Video */}
          <div className="flex-1 mx-auto sm:w-9/12 lg:w-auto">
            <iframe
              className="w-full h-64 rounded-2xl"
              src="https://www.youtube.com/embed/placeholder"
              title={t("services.facebook_api_conversions_youtube_video_title")}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </section>
    </div>

  );
}